import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    let title = "BharatCOD Online Shopping Cash On Delivery";

    const path = location.pathname;

    if (path === "/") {
      title =
        "BharatCOD Quick E Commerce for All Bharat | BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/cart") {
      title = "Your Cart - BharatCOD Online Shopping Cash On Delivery";
    } else if (path.startsWith("/product/")) {
      const productId = path.split("/")[2];
      title = `Product ${productId} - BharatCOD Online Shopping Cash On Delivery`;
    } else if (path === "/about-us/") {
      title = "About Us - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/contact-us/") {
      title = "Contact Us - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Wishlist") {
      title = "Your Wishlist - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Checkout") {
      title = "Checkout - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Address") {
      title = "Manage Address - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Profile") {
      title = "Your Profile - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/my-account/") {
      title = "My Account - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Register") {
      title = "Register - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/return-policy/") {
      title = "Return Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/delivery-information/") {
      title =
        "Delivery Information - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/shipping-policy/") {
      title = "Shipping Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/pricing-and-payments-policy/") {
      title =
        "Pricing & Payment Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/disclaimer-policy/") {
      title = "Disclaimer Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/prebooking-terms-and-conditions/") {
      title = "Prebooking T&Cs - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/refund-return/") {
      title = "Refund & Return - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/terms-of-service/") {
      title = "Terms of Service - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/privacy-policy-2/") {
      title = "Privacy Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/faq/") {
      title = "FAQs - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/how-to/") {
      title = "How to Use - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/track-your-order/") {
      title = "Track Your Order - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/vendor-register/") {
      title = "Vendor Register - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/SellerRegister") {
      title = "Seller Register - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/GstRegistration") {
      title = "GST Registration - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/SellerLogin") {
      title = "Seller Login - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/ThankYouPage") {
      title = "Thank You - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/TopSellDetails") {
      title =
        "Top Selling Products - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/offers") {
      title = "Offers & Coupons - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/cancellation-and-return-policy/") {
      title =
        "Cancellation & Return Policy - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/ViewAllCategory") {
      title = "All Categories - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/Getaddress") {
      title = "Saved Addresses - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/OtpScreen") {
      title = "OTP Verification - BharatCOD Online Shopping Cash On Delivery";
    } else if (path === "/AllProductData") {
      title = "Products - BharatCOD Online Shopping Cash On Delivery";
    } else if (path.startsWith("/category/")) {
      const parts = path.split("/");
      const productTitle = parts[3]?.replace(/-/g, " "); // Format hyphens to spaces
      title = `Buy ${decodeURIComponent(
        productTitle
      )} - BharatCOD Online Shopping Cash On Delivery`;
    }

    document.title = title;
  }, [location.pathname]);

  return null;
};

export default TitleManager;
